export async function setupLandingScrollReveal(
  root = '.landing-experiencia',
  item = '.block-reveal',
  visible = 'is-visible',
  maxMs = 1500
) {
  const getRoot = () => document.querySelector(root);
  await new Promise(resolve => {
    let last = 0;
    let stable = 0;
    const t0 = performance.now();
    const tick = () => {
      const h = getRoot()?.scrollHeight ?? 0;
      stable = h > 0 && h === last ? stable + 1 : 0;
      last = h;
      if (stable >= 6 || performance.now() - t0 > maxMs) resolve();
      else requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  });

  const els = document.querySelectorAll(`${root} ${item}`);
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(el => el.classList.add(visible));
    return () => {};
  }

  const io = new IntersectionObserver(
    entries => {
      for (const { isIntersecting, target } of entries) {
        if (!isIntersecting) continue;
        target.classList.add(visible);
        io.unobserve(target);
      }
    },
    { threshold: 0, rootMargin: '0px 0px -12% 0px' }
  );
  els.forEach(el => io.observe(el));
  return () => io.disconnect();
}
